import { createFileRoute } from "@tanstack/react-router";
import { LogScreen } from "../screens/staff/LogScreen.tsx";

/** `/sysadmin/log`: what Adea's staff looked at and did. */
export const Route = createFileRoute("/_staff/sysadmin/log")({
  component: LogScreen,
});
